import { Onboarding, ApiClientError } from '@raydiant/api-client-js';
import { keys } from '../queryClient';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';

export default function useOnboardingStatus() {
  return useProtectedQuery<Onboarding[], ApiClientError>(
    keys.onboarding(),
    () => raydiant.getOnboardingStatus(),
  );
}
